module.exports = __webpack_public_path__ + "pr.svg?db39d157f68dacf306f80c9ae33b2115";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pr.svg
// module id = 1164
// module chunks = 27